export default {
  en: {
    common_actions: {
      cancel: 'Cancel',
      submit: 'Submit',
      edit: 'Edit',
      delete: 'Delete',
    },
    toggle_menu_label: 'Toggle menu',
    are_you_sure: 'Are you sure?',
    snack: {
      generic_error_msg:
        'Something went wrong! Please try again later or contact us.',
    },
  },
};
